import React, { useState, useEffect } from "react";
import "./styles.css";
import { compose } from "redux";
import {
  Button,
  Form,
  Message,
  Container,
  Grid,
  Segment,
} from "semantic-ui-react";
import { Link, withRouter } from "react-router-dom";
import { firebaseConnect } from "react-redux-firebase";
import { connect } from "react-redux";
import FacebookProvider from "./Facebook/FacebookProvider";

const { Column } = Grid;
const Login = ({ firebase, history, location, profile }) => {
  const INITIAL_USER = {
    email: "",
    password: "",
  };
  const [user, setUser] = useState(INITIAL_USER);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const isUser = Object.values(user).every((element) => Boolean(element));
    isUser ? setDisabled(false) : setDisabled(true);
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      await firebase
        .auth()
        .signInWithEmailAndPassword(user.email, user.password);
      history.push("/");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  if (!profile.isEmpty) {
    history.push("/");
  }
  return (
    <div className="container-Sections">
      <Container className="login-container w-50">
        <Segment padded>
          <Grid centered>
            <Column largeScreen={8} computer={8} tablet={16} mobile={16}>
              <div style={{ margin: "0 auto" }}>
                <div className="alert alert-light text-center" role="alert">
                  <p className="h3 font-weight-normal">
                    ¿Ya eres <span className="font-weight-bold">miembro</span>?
                  </p>
                </div>
                <Form
                  error={Boolean(error)}
                  onSubmit={handleSubmit}
                  loading={loading}
                >
                  <Message error header="Oops!" content={error} />
                  <Form.Input
                    placeholder="Correo"
                    name="email"
                    onChange={handleChange}
                    value={user.email}
                    type="email"
                  />
                  <Form.Input
                    placeholder="Contraseña"
                    name="password"
                    onChange={handleChange}
                    value={user.password}
                    type="password"
                  />
                  <Link
                    to="/forgotpassword"
                    role="button"
                    className="font-weight-bold forgot-password-link"
                  >
                    ¿Olvidaste tu contraseña?
                  </Link>
                  <Button
                    className="mb-5"
                    type="submit"
                    color="black"
                    content="Ingresar"
                    disabled={disabled || loading}
                  />
                </Form>
              </div>
              {false && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <FacebookProvider history={history} />
                </div>
              )}
            </Column>
            <Column
              largeScreen={8}
              computer={8}
              tablet={16}
              textAlign="center"
              mobile={16}
            >
              <div
                className="view login-register-container"
                style={styles.backgroundView}
              >
                <div className="inner-register-container">
                  <div className="text-center login-question-text">
                    <p className="font-weight-bold">
                      ¿No tienes una{" "}
                      <span className="font-weight-bold">cuenta</span>?
                    </p>
                  </div>
                  <div>
                    <Link
                      to="/signup"
                      role="button"
                      className="btn font-weight-bold "
                      style={styles.btnRegister}
                    >
                      Registrarse
                    </Link>
                  </div>
                </div>
              </div>
            </Column>
          </Grid>
        </Segment>
      </Container>
    </div>
  );
};

export default compose(
  withRouter,
  firebaseConnect(),
  connect(({ firebase: { profile } }) => ({ profile }))
)(Login);

// Styles
const styles = {
  buttons: {},
  backgroundView: {},
  btnRegister: {
    backgroundColor: "#C9A559",
    color: "white",
    fontSize: "1rem",
  },
  btnPass: { backgroundColor: "#C9A559", color: "white", fontSize: "1rem" },
};
